import { render, staticRenderFns } from "./ProductIcon.vue?vue&type=template&id=0b90fab4&scoped=true&"
import script from "./ProductIcon.vue?vue&type=script&lang=ts&"
export * from "./ProductIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ProductIcon.vue?vue&type=style&index=0&id=0b90fab4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90fab4",
  null
  
)

export default component.exports